import { createRouter, createWebHashHistory } from 'vue-router'
import store from '@/store'

import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import EventView from '../views/EventView.vue'
import ProductView from '../views/ProductView.vue'
import OrdersView from '../views/OrdersView.vue'
import CartView from '@/views/CartView.vue'
import ProfileView from '@/views/ProfileView.vue'
import CheckoutView from '@/views/CheckoutView.vue'
import PurchaseSuccessView from '@/views/PurchaseSuccessView.vue'
import PurchaseWaitingView from '@/views/PurchaseWaitingView.vue'
import RegisterView from '@/views/RegisterView.vue'
import MyCardsView from '@/views/MyCardsView.vue'
import ProfileDataView from '@/views/ProfileDataView.vue'
import RecoverPasswordView from '@/views/RecoverPasswordView.vue'
import UpdatePasswordView from '@/views/UpdatePasswordView.vue'
import QrCodeCheckoutView from '@/views/QrCodeCheckoutView.vue'
import ConfirmCodeView from '@/views/ConfirmCodeView.vue'
import ReadQrCodeView from '@/views/ReadQrCodeView.vue'
import LogsView from '@/views/LogsView.vue'
import CartController from '@/assets/controllers/CartController'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
    meta: {
      guest: true
    }
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/orders',
    name: 'orders',
    component: OrdersView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/event',
    name: 'event',
    component: EventView,
    meta: {
      openInMiniApp: false // solucao paliativa para a demanda Sodexo, para que alunos nao tenham acesso ao cardapio dos funcionarios
    }
  },
  {
    path: '/productitem',
    name: 'productitem',
    component: ProductView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/cart',
    name: 'cart',
    component: CartView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView
  },
  {
    path: '/checkout',
    name: 'checkout',
    component: CheckoutView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/purchase-success',
    name: 'purchasesuccess',
    component: PurchaseSuccessView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/waiting-success',
    name: 'PurchaseWaiting',
    component: PurchaseWaitingView,
    meta: {
      openInMiniApp: true
    }
  },
  {
    path: '/register',
    name: 'register',
    component: RegisterView,
    meta: {
      guest: true
    }
  },
  {
    path: '/my-cards',
    name: 'mycards',
    component: MyCardsView
  },
  {
    path: '/profile-data',
    name: 'profiledata',
    component: ProfileDataView
  },
  {
    path: '/recover-password',
    name: 'recoverpassword',
    component: RecoverPasswordView,
    meta: {
      guest: true
    }
  },
  {
    path: '/update-password',
    name: 'updatepassword',
    component: UpdatePasswordView
  },
  {
    path: '/qrcode-checkout/:productId',
    name: 'qrcodecheckout',
    component: QrCodeCheckoutView,
    meta: {
      guest: true,
      openInMiniApp: true
    }
  },
  {
    path: '/confirm-code',
    name: 'confirmcode',
    component: ConfirmCodeView,
    meta: {
      guest: true,
      openInMiniApp: true
    }
  },
  {
    path: '/read-qrcode',
    name: 'readqrcode',
    component: ReadQrCodeView,
    meta: {
      guest: true,
      openInMiniApp: true
    }
  },
  {
    path: '/logs',
    name: 'logs',
    component: LogsView
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

router.beforeEach((to, from, next) => {
  const sessionToken = localStorage.getItem('SESSION_TOKEN')
  const lastRoute = localStorage.getItem('lastRoute')

  const user = store.getters.getUser

  // verificacao para mini app
  const isFullApp = store.getters.isFullApp
  if (!isFullApp && !to.meta.openInMiniApp) {
    next('/read-qrcode')
    return
  }

  if (!to.meta.guest && (!sessionToken || sessionToken === null || !user) && isFullApp) {
    next('/login')
    return
  }

  // page reload
  if (from.matched.length === 0 && to.path === lastRoute && to.path !== '/' && isFullApp) {
    CartController.clearCart()
    next('/')
    return
  }

  // salvar ultima rota
  if (isFullApp && to.path !== '/login' && to.path !== '/register') {
    localStorage.setItem('lastRoute', to.path)
  }

  next()
})

export default router
